// @core/api/endpoints/team/list_team_invitations.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTeamInvitationsResponse,
} from '../../../types/team';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/team';

/**
 * List team invitations
 * Returns all pending, accepted, and declined invitations for a team. Useful for managing the invitation workflow.
 */
export async function ListTeamInvitations(
  team_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTeamInvitationsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/invitations`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.get<ListTeamInvitationsResponse>(requestPath, { ...requestOptions, params });
}
